// The scenario picker — a port of `ui/HomeScreen.kt`.
import Header from '../components/Header';
import { useStore } from '../store';

export default function HomeScreen() {
  const s = useStore();
  const p = s.progress;

  return (
    <div className="screen">
      <Header
        title="AI tutor"
        subtitle="Your in-browser English tutor — no account, no API key"
        stats={[
          { value: String(p.streakDays), label: 'day streak' },
          { value: String(p.totalMessages), label: 'sentences' },
          { value: `${p.accuracy}%`, label: 'accuracy' },
        ]}
      />

      <div className="scroll">
        <div className="section-header">Pick a conversation</div>

        {s.scenarios.map((scenario) => (
          <button
            type="button"
            className="scenario"
            key={scenario.id}
            onClick={() => s.startScenario(scenario)}
          >
            <span className="emoji" aria-hidden="true">
              {scenario.emoji}
            </span>
            <span className="body">
              <span className="title">{scenario.title}</span>
              <span className="sub">{scenario.subtitle}</span>
            </span>
            <span className="chip">{scenario.level}</span>
          </button>
        ))}

        <p className="muted">
          Everything runs in this tab: the grammar coaching, the conversation and your progress,
          which is stored in this browser only. Speaking uses the browser's own speech services.
        </p>
      </div>
    </div>
  );
}
